import { Component, OnInit } from "@angular/core";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { WorkerService } from "../../services/worker.service";
import { SnackbarService } from "./../../services/snackbar.service";

@Component({
  selector: "app-obter-cargas",
  templateUrl: "./obter-cargas.component.html",
  styleUrls: ["./obter-cargas.component.css"],
})
export class ObterCargasComponent implements OnInit {
  constructor(
    private workerService: WorkerService,
    private snackBarService: SnackbarService
  ) {}

  fundsEnabled = true;
  accountsEnabled = true;
  managersEnabled = true;
  investedFundsEnabled = true;
  acquiredFundsEnabled = true;
  ballastEnabled = true;
  shareholdersEnabled = true;
  fundStockEnabled = true;
  fixedIncomeEnabled = true;
  variableIncomeEnabled = true;
  otherAssetEnabled = true;
  derivativeEnabled = true;
  swapCetipEnabled = true;

  ngOnInit() {}

  getFunds() {
    this.runWorker(WorkerService.Workers.Funds);
    this.fundsEnabled = false;
  }

  getAcquiredFunds() {
    this.runWorker(WorkerService.Workers.AcquiredFunds);
    this.acquiredFundsEnabled = false;
  }

  getAccounts() {
    this.runWorker(WorkerService.Workers.Accounts);
    this.accountsEnabled = false;
  }

  getManagers() {
    this.runWorker(WorkerService.Workers.Managers);
    this.managersEnabled = false;
  }

  getInvestedFunds() {
    this.runWorker(WorkerService.Workers.InvestedFunds);
    this.investedFundsEnabled = false;
  }

  getBallast() {
    this.runWorker(WorkerService.Workers.Ballast);
    this.ballastEnabled = false;
  }

  getShareholders() {
    this.runWorker(WorkerService.Workers.Shareholders);
    this.shareholdersEnabled = false;
  }

  getFundStock() {
    this.runWorker(WorkerService.Workers.FundStock);
    this.fundStockEnabled = false;
  }

  getFixedIncomeStock() {
    this.runWorker(WorkerService.Workers.FixedIncomeStock);
    this.fixedIncomeEnabled = false;
  }

  getVariableIncomeStock() {
    this.runWorker(WorkerService.Workers.VariableIncomeStock);
    this.variableIncomeEnabled = false;
  }

  getOtherAssetStock() {
    this.runWorker(WorkerService.Workers.OtherAssetStock);
    this.otherAssetEnabled = false;
  }

  getDerivativeStock() {
    this.runWorker(WorkerService.Workers.DerivativeStock);
    this.derivativeEnabled = false;
  }

  getSwapCetipStock() {
    this.runWorker(WorkerService.Workers.SwapCetipStock);
    this.swapCetipEnabled = false;
  }

  runWorker(worker: string) {
    const method = this.workerService.runWorker(worker);

    method
      .pipe(
        catchError((err) => {
          this.snackBarService.open(
            "Ocorreu um erro ao executar o serviço de cargas"
          );
          return throwError("Ocorreu um erro ao executar o serviço de cargas");
        })
      )
      .subscribe((res) => {
        this.snackBarService.open(
          "O serviço foi chamado com sucesso. Aguarde aproximadamente 1 minuto para os dados estarem atualizados"
        );
      });
  }
}
